import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import * as THREE from 'three';
import TiledGeometryLayer from "../../../Layer/TiledGeometryLayer";
import { globalExtentTMS } from "../../Geographic/Extent";
import CRS from "../../Geographic/Crs";
import PlanarTileBuilder from "./PlanarTileBuilder";

/**
 * @property {boolean} isPlanarLayer - Used to checkout whether this layer is a
 * PlanarLayer. Default is true. You should not change this, as it is used
 * internally for optimisation.
 */
var PlanarLayer = /*#__PURE__*/function (_TiledGeometryLayer) {
  _inherits(PlanarLayer, _TiledGeometryLayer);
  var _super = _createSuper(PlanarLayer);
  /**
   * A {@link TiledGeometryLayer} to use with a {@link PlanarView}. It has
   * specific method for updating and subdivising its grid.
   *
   * @constructor
   * @extends TiledGeometryLayer
   *
   * @param {string} id - The id of the layer, that should be unique. It is
   * not mandatory, but an error will be emitted if this layer is added a
   * {@link View} that already has a layer going by that id.
   * @param {Extent} extent - The extent to define the layer within.
   * @param {THREE.Object3d} [object3d=THREE.Group] - The object3d used to
   * contain the geometry of the TiledGeometryLayer. It is usually a
   * `THREE.Group`, but it can be anything inheriting from a `THREE.Object3d`.
   * @param {Object} [config] - Optional configuration, all elements in it
   * will be merged as is in the layer. For example, if the configuration
   * contains three elements `name, protocol, extent`, these elements will be
   * available using `layer.name` or something else depending on the property
   * name.
   * @param {number} [config.maxSubdivisionLevel=5] - Maximum subdivision
   * level for this tiled layer.
   * @param {number} [config.maxDeltaElevationLevel=4] - Maximum delta between
   * two elevations tile.
   *
   * @throws {Error} `object3d` must be a valid `THREE.Object3d`.
   */
  function PlanarLayer(id, extent, object3d) {
    var _this;
    var config = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    _classCallCheck(this, PlanarLayer);
    var tms = CRS.formatToTms(extent.crs);
    if (!globalExtentTMS.get(extent.crs)) {
      // Add new global extent for this new crs projection.
      globalExtentTMS.set(extent.crs, extent);
    }
    config.tileMatrixSets = [tms];
    _this = _super.call(this, id, object3d || new THREE.Group(), [extent], new PlanarTileBuilder({
      crs: extent.crs
    }), config);
    _this.isPlanarLayer = true;
    _this.extent = extent;
    _this.minSubdivisionLevel = _this.minSubdivisionLevel == undefined ? 0 : _this.minSubdivisionLevel;
    _this.maxSubdivisionLevel = _this.maxSubdivisionLevel == undefined ? 5 : _this.maxSubdivisionLevel;
    _this.maxDeltaElevationLevel = _this.maxDeltaElevationLevel || 4.0;
    return _this;
  }
  return _createClass(PlanarLayer);
}(TiledGeometryLayer);
export default PlanarLayer;